import { render, staticRenderFns } from "./ms-create-prescrip.vue?vue&type=template&id=bd630c30&scoped=true"
import script from "./ms-create-prescrip.vue?vue&type=script&lang=js"
export * from "./ms-create-prescrip.vue?vue&type=script&lang=js"
import style0 from "./ms-create-prescrip.vue?vue&type=style&index=0&id=bd630c30&prod&lang=scss&scoped=true"
import style1 from "./ms-create-prescrip.vue?vue&type=style&index=1&id=bd630c30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd630c30",
  null
  
)

export default component.exports